import { BASE_URL } from "../api/index"; // adjust path to match your project

// Normalizes a photo/file URL coming back from the API.
// - Already-absolute URLs (http/https) are returned as-is.
// - blob: URLs (from a freshly-picked local file preview) are returned as-is.
// - Relative paths (e.g. "/uploads/gallery/abc.jpg") get BASE_URL prefixed.
// - Anything falsy returns null so callers can show a fallback.
export function resolveMediaUrl(url) {
  if (!url) return null;
  if (url.startsWith("blob:")) return url;
  if (/^https?:\/\//i.test(url)) return url;
  const path = url.startsWith("/") ? url : `/${url}`;
  return `${BASE_URL}${path}`;
}